import { css } from '@linaria/core';
export const tooltipCls = "omponents__TruncatedText__TruncatedText_styles_ts-tooltipCls-tmvpghg";
export const contentPropsCls = "omponents__TruncatedText__TruncatedText_styles_ts-contentPropsCls-c1450clx";

require("./TruncatedText.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./TruncatedText.styles.ts");